import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PageMenu from "../../menus/PageMenu";
import PageContent from "../../layout/PageContent";
import OurExperience from "./OurExperience";
import Accreditations from "../../reusable/fieldGroups/Accreditations";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import { Box } from "@mui/system";
import InfoBanner from "../../layout/InfoBanner";
import OurPolicies from "./OurPolicies";
import ContentTabs from "../../layout/ContentTabs";
import RandomTestimonial from "../../reusable/RandomTestimonial";

export default function OurBusiness(){

    const [pageData, setPageData]=useState();

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['our-business'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug=our-business&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setPageData(data.data[0]);
        }
    },[data]);

    //console.log(pageData)

    return(
        <>
            <GlobalMeta/>
            <InternalBanner
                featuredImage={pageData?. _embedded?.['wp:featuredmedia']?.[0]?.source_url}
                banner={pageData?.acf.internal_banner}
            />
            <PageMenu
                items={pageData?.acf.page_menu}
                loading={!pageData}
            />
            <PageContent
                content={pageData?.content.rendered}
            />
            <ContentTabs
                data={pageData?.acf.content_tabs}
            />
            <OurExperience
                data={pageData?.acf.our_experience}
            />
            <RandomTestimonial
                testimonials={pageData?.acf.testimonials}
                loading={!pageData}
            />
            <Box sx={{height:'3rem'}}/>
            <Accreditations
                accreditations={pageData?.acf.accreditations}
                loading={!pageData}
            />
            <ImageBGSection
                content={pageData?.acf.image_background}
                loading={!pageData}
            />
            <InfoBanner
                data={pageData?.acf.info_banner}
            />
            <OurPolicies
                data={pageData?.acf.our_policies}
            />
        </>
    );
}